<template lang="pug">
  b-container(fluid)
    b-row
      b-col.page-wrap(cols="12")
        b-card-group.w-100
          b-card(no-body)
            div(slot="header") {{$t('add_user')}}
            b-list-group.list-input(flush)
              //- 아이디
              b-list-group-item
                b-row
                  b-col.label(cols="5" md="3" lg="2")
                    span {{$t('ID')}}
                  b-col(cols="7" md="9" lg="10") 
                    b-input-group
                      b-input-group-text(slot="append")
                        icon(name="check" :class="{'text-success': validates.mgrid && validates.exist}")
                      b-form-input(
                        type="email"
                        v-model="newUser.mgrid"
                        aria-describedby="inputEmailFeedback"
                        :placeholder="$t('user_page.enter_email')"
                        @input="isValidId"
                        maxlength="40"
                      )
                      div.validate-text ({{$t('user_page.enter_valid_email')}})
              
              //- 비밀번호
              b-list-group-item
                b-row
                  b-col.label(cols="5" md="3" lg="2")
                    span {{$t('PW')}}
                  b-col(cols="7" md="9" lg="10") 
                    b-input-group
                      b-input-group-text(slot="append")
                        icon(name="check", :class="{'text-success': validates.pw}")
                      b-form-input(
                        type="password"
                        v-model="newUser.pw"
                        aria-describedby="inputPwFeedback"
                        :placeholder="$t('user_page.enter_password')"
                        @input="isValidPw"
                        maxlength="12"
                      )
                      div.validate-text(v-if="!validates.pw && newUser.pw")
                      div.validate-text {{$t(validatePasswordLevels[this.password_level])}}
              
              //- 비밀번호 확인
              b-list-group-item
                b-row
                  b-col.label(cols="5" md="3" lg="2")
                    span {{$t('PW_confirm')}}
                  b-col(cols="7" md="9" lg="10") 
                    b-input-group
                      b-input-group-text(slot="append")
                        icon(name="check", :class="{'text-success': validates.pwConfirm}")
                      b-form-input(
                        type="password"
                        v-model="newUser.pwConfirm"
                        :placeholder="$t('user_page.reenter_password')"
                        @input="isValidPwConfirm"
                        maxlength="12"
                      )
                      div.validate-text(v-if="!validates.pwConfirm && newUser.pwConfirm")
                        | {{$t('password_confirm')}}

              //- 이름
              b-list-group-item
                b-row
                  b-col.label(cols="5" md="3" lg="2")
                    span {{$t('name')}}
                  b-col(cols="7" md="9" lg="10") 
                    b-input-group
                      b-input-group-text(slot="append")
                        icon(name="check", :class="{'text-success': validates.name}")
                      b-form-input(
                        type="text"
                        v-model="newUser.name"
                        :placeholder="$t('name_requirement')"
                        @input="validates.name = newUser.name !== ''"
                      )
              
              //- 부서
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2")
                    span {{$t('department')}}
                  b-col(cols="7" md="9" lg="10")
                    b-form-select(
                      size="sm"
                      v-model="newUser.department"
                      :options="departments"
                      style="width: auto"
                    )
              
              //- 직급
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2")
                    span {{$t('user_page.position')}}
                  b-col(cols="7" md="9" lg="10")
                    b-form-input(
                      type="text"
                      v-model="newUser.rank"
                      :placeholder="$t('user_page.enter_position')"
                      @input="validates.rank = newUser.rank !== ''"
                    )
              
              //- 직책
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2")
                    span {{$t('cowork_position')}}
                  b-col(cols="7" md="9" lg="10")
                    b-form-input(
                      type="text"
                      v-model="newUser.position"
                      :placeholder="$t('user_page.enter_job_title')"
                      @input="validates.position = newUser.position !== ''"
                    )
              
              //- 부서장 여부
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2")
                    span {{$t('user_page.is_department_head')}}
                  b-col(cols="7" md="9" lg="10")
                    switches.lmm-switch(
                      v-model="newUser.department_leader_flag"
                      theme="bootstrap"
                      :disabled="newUser.department === 1"
                      :color="newUser.department_leader_flag ? 'success' : 'default'"
                    )
              
              //- 사용자 권한
              b-list-group-item
                b-row
                  b-col.label(cols="5" md="3" lg="2")
                    span {{$t('user_page.user_permissions')}}
                  b-col(cols="7" md="9" lg="10")
                    b-form-select(
                      size="sm"
                      v-model="newUser.user_type"
                      :options="userAuthList"
                      style="width: auto"
                    )

              //- 결재단계
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2")
                    span {{$t('user_page.self_approval_step')}}
                  b-col(cols="7" md="9" lg="10")
                    b-form-select(
                      size="sm"
                      v-model="newUser.manage_seq"
                      :options="managesList"
                      style="width: auto"
                    )
              
              //- 사용자 결재단계
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2")
                    span {{$t('user_page.mandatory_approval_step_for_use_request')}}
                  b-col(cols="7" md="9" lg="10")
                    b-form-select(
                      size="sm"
                      v-model="newUser.approve_seq"
                      :options="manages.filter(item => item.value !== 9)"
                      style="width: auto"
                    )
              
              //- 매니저 한도
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2")
                    span {{$t('user_page.manager_limit')}}
                  b-col(cols="7" md="9" lg="10")
                    b-form-select(
                      size="sm"
                      v-model="newUser.mgrdev_limit"
                      :options="limits"
                      style="width: auto"
                    )
                    b-form-input.number.ml-2(
                      v-if="newUser.mgrdev_limit === 0"
                      type="number"
                      v-model="newUser.mgrdev_limit_direct"
                      :formatter="e => String(e).substring(0, 4)"
                    )
              
              //- 원격기기 한도
              b-list-group-item
                b-row
                  b-col.label(cols="5" md="3" lg="2")
                    span {{$t('user_page.remote_device_limit')}}
                  b-col(cols="7" md="9" lg="10")
                    b-form-select(
                      size="sm"
                      v-model="newUser.dev_limit"
                      :options="limits"
                      style="width: auto"
                      @change="handleDevLimitChange"
                    )
                    b-form-input.number.ml-2(
                      v-if="newUser.dev_limit === 0"
                      type="number"
                      v-model="newUser.dev_limit_direct"
                      :formatter="e => String(e).substring(0, 4)"
                      @change="validateDevLimitDirect"
                    )
              
              //- 파일 전송 권한
              b-list-group-item
                b-row
                  b-col.label(cols="5" md="3" lg="2")
                    span {{$t('user_page.file_transfer_permission')}}
                  b-col(cols="7" md="9" lg="10")
                    switches.lmm-switch(
                      v-model="newUser.auth_filemanager"
                      theme="bootstrap"
                      :color="newUser.auth_filemanager ? 'success' : 'default'"
                    )
              
              //- 사후결재 권한
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2")
                    span {{$t('user_page.post_approval_permission')}}
                  b-col(cols="7" md="9" lg="10")
                    switches.lmm-switch(
                      v-model="newUser.post_approval"
                      theme="bootstrap"
                      :color="newUser.post_approval ? 'success' : 'default'"
                    )
                    
        b-row.d-flex.flex-row-reverse.mr-2.mt-2(style="padding-right: 1rem;")
          b-btn.mt-2.save-btn(@click="next", size="sm" style="background-color: #EC7211;") {{$t('save')}}
          b-btn.mt-2.mr-1(@click="cancel" size="sm" style="") {{this.$t('cancel')}}
</template>

<script>
import _ from "lodash"
import Switches from "vue-switches"
import { UsersAPI, CheckAPI, ApprovalsAPI, CompanyFunctionAPI, DepartmentsAPI } from "@/api"
import { store } from "@/api/store"
import {user} from '@/api/access'

export default {
  name: "join-sub-component",
  components: { Switches },
  computed: {
    managesList() {
      let result = _.cloneDeep(this.manages)
      if (this.newUser.user_type === 1) {
        // 사용자
        result = result.filter(item => item.value === 0)
      }
      return result
    },
    userAuthList() {
      let result = _.cloneDeep(this.userAuth)
      if (this.newUser.department === 1 && this.accountType === 1) {
        // 무소속
        result = result.filter(item => item.value === 1)
      }
      return result
    },
    accountType() {
      return store.get('auth').account_type
    },
  },
  watch: {
    "newUser.department"(val) {
      if (val === 1) {
        // 무소속
        this.newUser.department_leader_flag = false
        this.newUser.user_type = 1
      }
    },
    "newUser.user_type"(val) {
      if (val === 1) {
        // 사용자
        this.newUser.manage_seq = 0
      }
    },
    
  },
  data() {
    return {
      maxValue: null,
      departments: [],
      userInfo: null,
      manages: [
        { value: 0, text: this.$t('user_page.not_set') },
        { value: 9, text: this.$t('user_page.global_settings') },
        { value: 1, text: `1${this.$t('user_page.step')}` },
        { value: 2, text: `2${this.$t('user_page.step')}` },
        { value: 3, text: `3${this.$t('user_page.step')}` },
        { value: 4, text: `4${this.$t('user_page.step')}` },
      ],
      limits: [
        { value: 1, text: "1" },
        { value: 2, text: "2" },
        { value: 3, text: "3" },
        { value: 4, text: "4" },
        { value: 5, text: "5" },
        { value: 6, text: "6" },
        { value: 7, text: "7" },
        { value: 8, text: "8" },
        { value: 9, text: "9" },
        { value: 10, text: "10" },
        { value: 0, text: this.$t('manual_input') },
      ],
      userAuth: [
        { value: 1, text: this.$t('user') },
        { value: 6, text: this.$t('mid_manager') },
        { value: 3, text: this.$t('policy_manager') },
      ],
      newUser: {
        mgrid: null,
        pw: null,
        pwConfirm: null,
        name: null,
        department: 1,
        rank: "",
        position: "",
        department_leader_flag: false,
        user_type: 1,
        use_approval: false,
        manage_seq: 0,
        approve_seq: 0,
        mgrdev_limit: 1,
        mgrdev_limit_direct: null,
        dev_limit: 1,
        dev_limit_direct: null,
        auth_filemanager: false,
        post_approval: false,
        time_zone_id: 32, // 시간대 32 고정
        lang_code: "ko", // 언어 모드 ko 고정
      },
      validates: {
        mgrid: false,
        pw: false,
        name: false,
        pwConfirm: false,
        rank: false,
        position: false,
        exist: true,
        approver: false,
      },
      validatePasswordLevels: ["password_level0", "password_level1", "password_level2", "password_level3"],
      apply: false,
      enabled: false,
      useRefresh: false,
      password_level: null,
      myData: null,
      user: {
        searchManager: "",
      },
      wait: {
        searchManager: false,
      },
      selectedManager: false,
      manager: {
        id: null,
        name: null,
      },
    }
  },
  methods: {
    fetchDepartment() {
      DepartmentsAPI.get().then(resp => {
        this.departments = resp.data.objects.map(item => {
          return {
            ...item,
            text: item.part_name,
            value: item.pk,
          }
        })
      })
    },
    next() {
      const vd = this.validates
      if (!vd.mgrid) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: "invalid_id" },
        })
        return
      }
      if (!vd.exist) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: "id_exist" },
        })
        return
      }
      if (!vd.pw) {
        switch (this.password_level) {
          case 0:
            this.AppState.$emit("show-message-dialog", {
              title: "LinkMeMine",
              context: { path: "password_level0" },
            })
            break
          case 1:
            this.AppState.$emit("show-message-dialog", {
              title: "LinkMeMine",
              context: { path: "password_level1" },
            })
            break
          case 2:
            this.AppState.$emit("show-message-dialog", {
              title: "LinkMeMine",
              context: { path: "password_level2" },
            })
            break
          case 3:
            this.AppState.$emit("show-message-dialog", {
              title: "LinkMeMine",
              context: { path: "password_level3" },
            })
            break
        }
        return
      }
      if (!vd.pwConfirm) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: "password_confirm" },
        })
        return
      }
      if (!vd.mgrid) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: 'user_page.name_requirement' },
        })
        return
      }
      if (!vd.rank) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: 'user_page.enter_position' },
        })
        return
      }
      if (!vd.position) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: 'user_page.enter_job_title' },
        })
        return
      }
      
      if (this.userInfo.license.total.primaryProdType === 'Basic' && this.userInfo.create_member_cnt >= 2 ) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: 'user_page.basic_user_limit' },
        })
        return
      }
      const params = _.cloneDeep(this.newUser)
      params.department_leader_flag = params.department_leader_flag ? 1 : 0
      params.department = String(params.department)
      delete params.pwConfirm

      if (params.mgrdev_limit === 0) {
        params.mgrdev_limit = parseInt(params.mgrdev_limit_direct)
      }
      if (params.dev_limit === 0) {
        params.dev_limit = parseInt(params.dev_limit_direct)
      }

      UsersAPI.post("", params).then(resp => {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: "created_user" },
        })
        this.$router.push({ name: "managers" })
      })
    },
    isValidPw() {
      let pw = this.newUser.pw
      switch (this.password_level) {
        case 1:
          this.validates.pw = /^(?=.*?[a-zA-Z])(?=.*?[0-9]).{6,12}$/.test(pw)
          break
        case 2:
          this.validates.pw = /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(pw)
          break
        case 3:
          this.validates.pw = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(pw)
          break
        default:
          this.validates.pw = /^.{4,12}$/.test(pw)
          break
      }
    },
    isValidPwConfirm() {
      let pw = this.newUser.pw
      let pwConfirm = this.newUser.pwConfirm
      if (pwConfirm && pw === pwConfirm) {
        this.validates.pwConfirm = true
      } else {
        this.validates.pwConfirm = false
      }
    },
    isValidId: _.debounce(function() {
      let id = this.newUser.mgrid
      if (!id) {
        this.validates.mgrid = false
        this.validates.exist = true
        return
      }
      // eslint-disable-next-line no-useless-escape
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(id)) {
        this.validates.mgrid = true
        let params = {
          timestamp: _.now(),
          type: "email",
          value: id,
        }
        CheckAPI.get("", { params }).then(({ data }) => {
          this.validates.exist = data.objects.available
        })
      } else {
        this.validates.mgrid = false
      }
    }),
    async getData() {
      const resp = await CompanyFunctionAPI.get()
      this.password_level = resp.data.objects[0].password_level
    },
    getUserData() {
      this.myData = store.get("user")
    },
    cancel() {
      this.$router.back()
    },
    initializeValidation() {
      if (this.accountType === 0) {
        this.validates.rank = true
        this.validates.position = true
      }
    },
    handleDevLimitChange(value) {
      if (value > this.maxValue) {
        this.newUser.dev_limit = this.maxValue
        const warningMessage = this.$t('user_page.dev_limit_warning', { maxValue: this.maxValue })
        this.$awn.warning(warningMessage)
      } else {
        this.newUser.dev_limit = value
      }
    },
    validateDevLimitDirect(value) {
      if (value > this.maxValue) {
        this.newUser.dev_limit_direct = this.maxValue
        const warningMessage = this.$t('user_page.dev_limit_warning', { maxValue: this.maxValue })
        this.$awn.warning(warningMessage)
      } else if(value < 0) {
        this.newUser.dev_limit_direct = 1
      } else {
        this.newUser.dev_limit_direct = value
      }
    },
  },
  mounted() {
    this.fetchDepartment()
    this.getData()
    this.getUserData()
    this.initializeValidation()
    
    this.userInfo = user()
    this.maxValue = this.userInfo.license.list[0].pay_dev_vol
  },
}
</script>

<style lang="scss" scoped>
.row,
.col,
.container-fluid,
.col-12 {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.label {
  display: flex;
  align-items: center;
  min-height: 38px;
  & + div {
    display: flex;
    align-items: center;
  }
}

.list-input {
  .list-group-item {
    padding: 4px;
  }
  .form-control {
    border: 0;
    &:focus {
      box-shadow: none;
    }
    &::placeholder {
      color: #ccc;
    }
  }
  .input-group-text {
    color: #ccc;
    border: 0;
    background-color: transparent;
    min-width: 46px;
    svg {
      margin: 0 auto;
    }
  }
  .approver {
    color: dimgrey;
  }
  .fas {
    margin-left: 5px;
    cursor: pointer;
  }
}

.validate-text {
  font-size: 10px;
  line-height: 36px;
  color: #bdbdbd;
}

.d-flex > .btn {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  font-weight: 600;
  width: 5rem;
  border-radius: 4px;
  height: 1.5rem;
}

.btn-secondary {
  color: black !important;
  background-color: #ffffff;
  width: 3rem;
  font-weight: 400;
}

.btn-primary {
  color: black;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #f7f7f7 !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #cbcbcb !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

.save-btn {
  color: #000000 !important;
  background-color: #ff9900 !important;
  border: 1px solid #ff9900 !important;
  font-weight: 400;
}

.save-btn:hover {
  color: #000000 !important;
  background-color: #ec7211 !important;
  border: 1px solid #ff9900 !important;
  font-weight: 400;
}

.col-1 {
  padding: 0;
}

.list-input .form-control.number {
  border: 1px solid #ccc;
  height: 28px;
  width: 90px;
  font-size: 12px;
}
</style>
